/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { WebpageImage } from "cms/image/webpage-image";
import { useSimWebpage } from "cms/hooks/use-sim-webpage";

const FeatureWebpage = (props) => {

    const navigate = useNavigate();

    const web = props?.webpage;
    const webpageCard = props?.webpageCard;
    const total = props?.total;

    const webpage_guid = web?.webpage;
    // const guid = web?.guid;
    const description = web?.description;
    const title = web?.title;

    const { webpage } = useSimWebpage(webpage_guid);

    const path = webpage_guid?.path;

    const onClick = (event) => {
        event.stopPropagation();
        navigate(path);
    };

    return (
        <Fragment>
            {webpage_guid &&
                <div
                    className={`feature-webpage-content ${webpageCard}_full_width_${total % 3}`}
                    onClick={onClick}
                >
                    <WebpageImage
                        webpage_guid={webpage_guid}
                    />
                    <div className="webpage-content-text">
                        {" "}
                        <h3>
                            <a href={webpage?.path} className="cta-link-style">
                                {title}
                            </a>
                        </h3>
                        <p>{description}</p>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export { FeatureWebpage };
